import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["hosting"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { DateUtils } from '@atlassian/mpac-utils';

function transformGetReviewsResponse(response) {
  var _response$_links$next;

  const {
    averageStars,
    count
  } = response;
  const reviews = response._embedded.reviews;
  const moreReviewsEndpoint = (_response$_links$next = response._links.next) === null || _response$_links$next === void 0 ? void 0 : _response$_links$next.href;
  const transformedReviews = reviews.map(reviewData => {
    const {
      _embedded,
      totalVotes,
      stars,
      date,
      id,
      helpfulVotes,
      hosting,
      review
    } = reviewData;
    const author = _embedded.author;
    const transformedAuthor = {
      name: author.name,
      picture: author._links.picture.href,
      profileUrl: author._links.alternate.href
    };
    const vendorResponse = _embedded.response;
    const transformedVendorResponse = {
      response: vendorResponse === null || vendorResponse === void 0 ? void 0 : vendorResponse.text
    };
    const transformedRatings = {
      numRatings: totalVotes,
      avgStars: stars
    };
    return {
      id,
      helpfulVotes,
      hosting,
      review,
      date: DateUtils.longDate(date),
      ratings: transformedRatings,
      author: transformedAuthor,
      vendor: transformedVendorResponse
    };
  });
  const reviewsResponse = {
    ratings: {
      numRatings: count,
      avgStars: averageStars
    },
    reviews: transformedReviews,
    hasMoreReviews: !!moreReviewsEndpoint,
    moreReviewsEndpoint
  };
  return reviewsResponse;
}

export const getReviewsEndpoint = (appKey, queryParams) => {
  const {
    hosting
  } = queryParams,
        restParams = _objectWithoutProperties(queryParams, _excluded);

  const params = _objectSpread({
    limit: '5',
    hosting: hosting.toLowerCase()
  }, restParams);

  const queryString = new URLSearchParams(params).toString();
  return "/rest/2/addons/".concat(appKey, "/reviews?").concat(queryString);
};
export const getReviews = async reviewsUrl => {
  try {
    const response = await fetchOk(reviewsUrl);
    const reviewsResponse = await response.json();
    return transformGetReviewsResponse(reviewsResponse);
  } catch (error) {
    throw new Error(error);
  }
};